import React from "react";

import { renderResultHistory } from "@/modules/commonPopupResultHistory";
import { IPopupResultHistoryProps } from "@/types/PopupResultHistoryTypes";

import "../index.scss";
import { getBasePcode } from "@/modules/gamePcode";

interface IState {
	showDetail: boolean,
	idxDetail: number
}

//Todo: make this work
//48D, based on 24D
export default class M17 extends React.Component<IPopupResultHistoryProps, IState> {
	state = { showDetail: false, idxDetail: null }

	handleShowDetail(idx) {


		this.setState({
			showDetail: !this.state.showDetail,
			idxDetail: idx
		})

		console.log("data detail", idx)
	}

	render() {
		// Template consts
		const { langdata, orientation } = this.props;

		const basePcode = getBasePcode(this.props.activeGame.pcode);
		
		// PORTRAIT TAB NAMES
		const tabNames = ["48D"];

		// HEADERS
		const landscapeHeaders = [
			langdata["txt_date"],
			langdata["txt_periode"],
			langdata["txt_number"],
			// langdata["txt_action"]
		];

		const detailHeader = [
			"Nomor Keluar",
			"AS",
			"KOP",
			"KEPALA",
			"EKOR"
		];
		
		// TAB HEADER ELEMENTS
		const portraitHeaderIndices = (
			this.props.portraitTabIndex === 0 ? [0, 1, 2, 3] : null
		);
		
		// TABLE BODY
		const bodyMapFunction = (item, idx) => {
			const cells = [
				item.tanggal,
				item.periode,
				<div key={"nomor_keluar_" + idx} style={{width: "unset"}}>
					{
						item.angka.split("").map(it => <span key={"res-"+idx}>{it} </span>)
					}
				</div>,
				// <button className="btn-detail" key={`btnDetail-${idx}`} onClick={() => this.handleShowDetail(idx)}>Detail</button>
			];
			
			//Template functions start here
			const landscapeColumns = cells.map((cell, _idx) =>
				<td key={"lC_" + _idx}>
					{cell}
				</td>
			), portraitColumns = portraitHeaderIndices.map((num, _idx) =>
				<td key={"pC_" + this.props.portraitTabIndex + _idx}>
					{ cells[num] }
				</td>
			);
		
			return (
				<tr key={"tpdhm_" + idx} >
					{
						orientation === "landscape" ?
						landscapeColumns : portraitColumns
					}
				</tr>
			);
		};


		const bodyDetailFunction = (item, idx) => {
			return (
				<tbody>
					<tr key={"tp4d_" + idx}>
						<td>4D</td>
						{
							item['4d'].split("").map((sNum, _idx) => <td key={`as4d-${idx}-${sNum}`}>{sNum}</td>)
						}
					</tr>
					<tr key={"tp3d_" + idx}>
						<td>3D</td>
						{
							item['3d'].split("").map((sNum, _idx) => <td key={`as3d-${idx}-${sNum}`}>{sNum}</td>)
						}
					</tr>
					<tr key={"tp2d_" + idx}>
						<td>2D</td>
						{
							item['2d'].split("").map((sNum, _idx) => <td key={`as2d-${idx}-${sNum}`}>{sNum}</td>)
						}
					</tr>
					<tr key={"tpcb_" + idx}>
						<td>Colok Bebas</td>
						{
							item['colok-bebas'].split("").map((sNum, _idx) => <td key={`ascb-${idx}-${sNum}`}>{sNum}</td>)
						}
					</tr>
					<tr key={"tpkb_" + idx}>
						<td rowSpan={2}>Kombinasi</td>
						{
							item['kombinasi'][0].split(",").map((sNum, _idx) => <td key={`askb-${idx}-${sNum}`}>{sNum}</td>)
						}
					</tr>
					<tr key={"tpkb2_" + idx}>
						{
							item['kombinasi'][1].split(",").map((sNum, _idx) => <td key={`askb2-${idx}-${sNum}`}>{sNum}</td>)
						}
					</tr>
					<tr key={"tpcj_" + idx}>
						<td>Colok Jitu</td>
						{
							item['colok-jitu'].split("").map((sNum, _idx) => <td key={`ascj-${idx}-${sNum}`}>{sNum}</td>)
						}
					</tr>
					<tr key={"tpff_" + idx}>
						<td rowSpan={2}>50-50</td>
						{
							item['50-50'][0].split(",").map((sNum, _idx) => <td key={`asff-${idx}-${sNum}`}>{sNum}</td>)
						}
					</tr>
					<tr key={"tpff2_" + idx}>
						{
							item['50-50'][1].split(",").map((sNum, _idx) => <td key={`asff2-${idx}-${sNum}`}>{sNum}</td>)
						}
					</tr>
					<tr key={"tpcb2d_" + idx}>
						<td>Colok Bebas 2D</td>
						<td colSpan={4}>{ item['colok-bebas-2d'] }</td>
					</tr>

					<tr key={"tpshi_" + idx}>
						<td>Shio</td>
						<td colSpan={4}>{ item['shio'] }</td>
					</tr>
					<tr key={"tpsh_" + idx}>
						<td>Silang Homo</td>
						<td colSpan={4}>{ item['silang-homo'] }</td>
					</tr>
					<tr key={"tptt_" + idx}>
						<td>Tengah Tepi</td>
						<td colSpan={4}>{ item['tengah-tepi'] }</td>
					</tr>
					<tr key={"tpkkk_" + idx}>
						<td>Kembang Kempis Kembar</td>
						<td colSpan={4}>{ item['kembang-kempis-kembar'] }</td>
					</tr>
					<tr key={"tpds_" + idx}>
						<td>Dasar</td>
						<td colSpan={4}>{ item['dasar'] }</td>
					</tr>
				</tbody>
			);
		}
		

		// Template Tab Headers, no need to change
		const headers = this.state.showDetail ? 
							detailHeader : 
							orientation === "landscape" ?
								landscapeHeaders :
								portraitHeaderIndices.map(num => landscapeHeaders[num]);

		// Template function, no need to change
		return renderResultHistory(
			this.props.activeGame.resultHistory,
			basePcode,
			headers,
			this.state.showDetail ? bodyDetailFunction : bodyMapFunction,
			
			this.props.gameResultHistoryPage,

			this.props.fetchResultHistory,
			this.props.changePortraitResultHistoryTab,
			
			{
				mobile: this.props.mobile,
				mobileHome: this.props.mobileHome,
				desktop: this.props.desktop,
				orientation: orientation,
				tabNames: tabNames,
				
				portraitTabIndex: this.props.portraitTabIndex,
				showGameResultHistoryLoadingOverlay: this.props.showGameResultHistoryLoadingOverlay
			},

			this.state.showDetail,
			this.state.idxDetail,
			this.handleShowDetail.bind(this)
		);
	}
}
